<template>
    <div class="section">
        <div class="bak">
            <h1 class="title is-size-2 is-size-3-mobile has-text-primary">Selskap</h1>
            <p class="is-size-5 is-size-6-mobile has-text-white">General Hotell er perfekt for selskaper i størrelsesorden 15 til 80 gjester. Hvert år gjennomfører vi drøssevis av forskjellige arrangementer med passende menyer. Prisene er gode og ikke minst - forutsigbare. Våre kokker lager mat som både barna og bestemor liker. </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">Etter at Covid-19 dukket opp ble det behov for å revurdere menyene våre. Dette av flere årsaker, ikke bare at det i perioder var uaktuelt å servere fra buffet. Alle våre menyer er nå fremdeles til vurdering - sammen med betingelser og priser for selskaper. Disse sidene vil blli oppdatert så snart denne revurderingen er gjennomført. </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">De til en hver tid rådende smittevernreglene vil dessverre også påvirke hvordan vi håndterer innbooking av selskaper.</p>
            <p class="is-size-5 is-size-6-mobile has-text-white has-text-centered has-text-weight-bold avsnitt2">
                <a href="/meny" target="_self">Klikk her for å se de menyene vi serverer på huset inntil videre.</a>
            </p>
            <!--
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">Her er en liste over de menyene vi har hatt tilgjengelige på disse sidene:
                <ul class="liste">
                    <li>Koldtbord</li>
                    <li>Spansk tapas</li>
                    <li>Tavola Italiana (italiensk "koldtbord")</li>
                    <li>Minnestundmenyer</li>
                    <li>3-retters festmenyer
                        <ul class="liste">
                            <li>Grilla kamskjell med sitron, Nduja og Salsa Verde<br/>Bistecca Fiorentina med bakte rotgrønnsaker, fondantpoteter og Sauce Bearnaise<br/>Crescia Sfogliata (italiensk eplestrudle) med vanilje og iskrem</li>
                            <li>Grilla svele med rakfisk, røkt agurk og gravet eggeplomme<br/>Braisert lammebog med pastinakk-krem, ratatouille og lammesjy<br/>Hvit sjokolademoussekake med bærmiks</li>
                            <li>Speket andebryst med sellerirot, syltet kantarell og brunet smør<br/>Langtidsstekt reinsdyrplomme med sitronglasert gulrot, kirsebærkompott og portvinfløtesaus<br/>Blåbærkrønsj</li>
                            <li>Lettgrilla tartar av okse med Hollandaise med hint av brent løk<br/>Kylling alla Mandrole<br/>Mokkakake</li>
                            <li>Gamberi alla busara<br/>Laubærbakt torsk med grov ertepurè, bacon og Oslosaus<br/>Madagaskarsjokolade med appelsin- og camparisaus</li>
                        </ul>
                    </li>
                </ul>
            </p>
            -->
            <p class="has-text-centered avsnitt2">
                <a class="button is-large is-success" href="mailto:booking@generalhotell.no?subject=Selskapsforespørsel">Send en forespørsel i dag!</a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    title: 'Selskaper - barnedåp, konfirmasjon, bryllup, julebord med mer',
    metaInfo: {
        meta: [
        { name: 'description', content: 'Her på General Hotell gjennomfører vi et stort antall selskaper hvert år: barnedåp, konfirmasjon, bryllup, jubileer, julebord og minnestund.'},
        { name: 'keywords', content: 'selskaper, tapas, 3-retters, jubileum, bursdag, barnedåp, konfirmasjon, konfirmasjoner, fødselsdag, festmenyer, koldtbord, tapas, spansk tapas, julebord, rakfisklag, minnestund' }
        ]
    },        
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.7;
    display: block;
    padding: 10px 10px 30px 10px;
    margin-bottom:100px;
}

.liste {
    list-style-type: circle;
    margin-left:20px;
}

.avsnitt {
    margin-top:1vw;
}

.avsnitt2 {
    margin-top:3vw;
    margin-bottom: 3vw;
}
</style>

